var map = {
	"./client-01.jpg": 97620,
	"./client-02.jpg": 27331,
	"./client-03.jpg": 84198,
	"./client-04.jpg": 3277,
	"./client-05.jpg": 51056,
	"./client-06.jpg": 65407,
	"./client-07.jpg": 57346,
	"./client-08.jpg": 11737,
	"./client-09.jpg": 90684,
	"./client-10.jpg": 42586,
	"./re-image-1.jpg": 28434,
	"./re-image-2.jpg": 82589,
	"./re-image-3.jpg": 14496,
	"./re-image-4.jpg": 4659,
	"./re-image-5.jpg": 59894,
	"./re-image-6.jpg": 52033,
	"./re-image-7.jpg": 62084,
	"./re-image-8.jpg": 73591,
	"./re-image-9.jpg": 5306
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 65715;